var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94099 15.8876C3.46361 11.5256 3.96461 7.74188 4.52824 3.36075C4.54399 3.23963 4.56311 3.10988 4.64111 3.02325C4.72624 2.92838 4.85749 2.91225 4.97786 2.90138C9.45386 2.50463 13.9479 2.35613 18.437 2.45663C18.5874 2.46 18.8135 1.76888 18.9185 1.88888C18.9999 1.98188 19.0231 2.118 19.0426 2.24625C19.4832 5.166 19.7465 8.11838 19.8316 11.0775C19.8747 12.5719 19.8721 14.0677 19.8241 15.5621C19.7836 16.8187 19.907 18.3656 19.4082 19.5135C19.1015 20.2189 18.5776 20.7409 17.9356 21.0604C17.1804 21.4357 16.3422 21.5381 15.5195 21.6356C13.6599 21.8561 11.8002 22.0766 9.94061 22.2971C8.54899 22.4621 7.00474 22.5829 5.89061 21.6424C5.00899 20.898 4.61036 19.6515 4.35274 18.4552C4.17011 17.6051 4.03549 16.7486 3.94099 15.8876Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8623 2.14609L18.7554 2.16822L15.8402 2.39284L14.0672 2.51209C10.2437 2.77647 7.73303 2.85559 4.99628 2.83347H4.51253L4.53241 2.95272C4.77053 5.29684 4.71503 7.50446 4.40566 11.43L4.18366 14.1217L4.12441 14.7296C3.88628 17.8668 3.83491 19.911 3.99766 21.951L4.01753 22.233L7.27778 22.3342L8.82466 22.374C13.16 22.4928 15.8885 22.4928 19.0059 22.3522L19.3708 22.3305H19.442L19.6085 19.6211L19.7154 17.5192C19.898 14.1618 19.9693 11.8747 19.9535 9.42559V8.51284C19.9914 6.52572 19.8073 4.54122 19.406 2.60434C19.3858 2.45472 19.328 2.31409 19.2395 2.19897H19.1998C19.0918 2.15472 18.9767 2.13672 18.8623 2.14609Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52002 17.5219C9.49702 17.6171 11.4444 17.6659 13.2879 17.6659C14.5591 17.6659 15.8199 17.643 17.0349 17.5976",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50244 13.9005C8.53107 14.0697 9.56344 14.154 10.5868 14.154C12.6838 14.154 14.7628 13.8057 16.7664 13.1183L16.7672 13.1209",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50537 9.80096C8.84862 9.95958 10.2091 10.0395 11.5546 10.0395C13.3726 10.0395 15.2067 9.89358 17.0064 9.60596",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5791 5.53955C9.60898 6.0848 11.6737 6.36268 13.7396 6.36268H13.74C14.8376 6.36268 15.9465 6.28318 17.0355 6.12718",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsIcon);
export default __webpack_public_path__ + "static/media/jobs-icon.bbfe662c5b0ff3d3321a72281966ce10.svg";
export { ForwardRef as ReactComponent };